module.exports = __webpack_public_path__ + "img/horizontal_7_2_3016.17e87009.png";